// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataTable_wrapper__aIcs_","tableContainer":"DataTable_tableContainer__3Ng1J","table":"DataTable_table__1xo2V","paginationWrapper":"DataTable_paginationWrapper__3Bydm"};